/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { Link } from "react-router-dom";
import noop from "lodash/fp/noop";

import {
  linkCss,
  NotificationIndicatorNavigation,
  containerCss,
} from "./styles";
import { LinkTo, TemplateId } from "../../../../../../globalTypes";
import { OverviewTemplateRouteState } from "../../../../../../utils/internalLinksParsing";

const TemplateCardNavigationView: FC<Props> = ({
  templateId,
  label,
  linkTo,
  onClick = noop,
}) => (
  <Link
    onClick={onClick}
    to={linkTo as LinkTo<unknown>} // Je třeba castovat state na unknown kvůli typing chybě v react-router-dom
    css={linkCss}
  >
    {label}
    <NotificationIndicatorNavigation
      templateId={templateId}
      onClick={onClick}
    />
  </Link>
);

type Props = {
  templateId: TemplateId;
  label: string;
  linkTo?: LinkTo<OverviewTemplateRouteState>;
  onClick?: () => void;
};

export type TemplateCardNavigationViewProps = Props;
export default TemplateCardNavigationView;
